import React, { useEffect, useRef, useState } from 'react';

const StackedHeadings = ({ phrases, dark = false, prefix, description }) => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(-1);

  useEffect(() => {
    const observers = [];
    phrases.forEach((_, i) => {
      const el = document.getElementById(`stack-${i}-${sectionRef.current?.dataset?.uid}`);
      if (!el) return;
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActive((prev) => Math.max(prev, i));
            }
          });
        },
        { threshold: 0.55 }
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, [phrases]);

  const uid = useRef(Math.random().toString(36).slice(2, 8)).current;

  return (
    <section
      ref={sectionRef}
      data-uid={uid}
      className={`relative py-28 lg:py-36 ${dark ? 'bg-neutral-950 text-white' : 'bg-white text-black'}`}
    >
      <div className={`absolute inset-0 pointer-events-none ${dark ? 'grid-backdrop--dark' : 'grid-backdrop'} opacity-40`} />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        {prefix && (
          <div className="flex items-center gap-3 mb-10">
            <span className={`w-8 h-[1.5px] ${dark ? 'bg-white/60' : 'bg-black/60'}`} />
            <span className={`font-mono-tech text-[10px] tracking-[0.3em] uppercase ${dark ? 'text-white/70' : 'text-black/60'}`}>{prefix}</span>
          </div>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-9">
            {phrases.map((p, i) => (
              <h2
                key={i}
                id={`stack-${i}-${uid}`}
                className={`ghost-heading ${dark ? 'ghost-heading--dark' : ''} ${active >= i ? 'is-active' : ''} text-[56px] sm:text-[88px] lg:text-[128px] xl:text-[148px]`}
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                {p}
              </h2>
            ))}
          </div>
          {description && (
            <div className="lg:col-span-3 flex items-end">
              <div>
                <div className={`w-10 h-[1.5px] mb-4 ${dark ? 'bg-white/60' : 'bg-black/60'}`} />
                <p className={`font-body text-base leading-relaxed ${dark ? 'text-white/80' : 'text-black/70'}`}>{description}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default StackedHeadings;
